import { createAction } from "redux-actions";

export const FETCH_CONSUMER_CHARTS_DATA = "FETCH_CONSUMER_CHARTS_DATA";
export const fetchConsumerChartsData = createAction(FETCH_CONSUMER_CHARTS_DATA);

export const FETCH_CONSUMER_CHARTS_DATA_FAILURE = "FETCH_CONSUMER_CHARTS_DATA_FAILURE";
export const fetchConsumerChartsDataFailure = createAction(FETCH_CONSUMER_CHARTS_DATA_FAILURE);

export const FETCH_CONSUMER_CHARTS_DATA_REQUESTED = "FETCH_CONSUMER_CHARTS_DATA_REQUESTED";
export const fetchConsumerChartsDataRequested = createAction(FETCH_CONSUMER_CHARTS_DATA_REQUESTED);

export const FETCH_CONSUMER_CHARTS_DATA_SUCCESS = "FETCH_CONSUMER_CHARTS_DATA_SUCCESS";
export const fetchConsumerChartsDataSuccess = createAction(FETCH_CONSUMER_CHARTS_DATA_SUCCESS);

export const FETCH_BUSINESS_CHARTS_DATA = "FETCH_BUSINESS_CHARTS_DATA";
export const fetchBusinessChartsData = createAction(FETCH_BUSINESS_CHARTS_DATA);

export const FETCH_BUSINESS_CHARTS_DATA_FAILURE = "FETCH_BUSINESS_CHARTS_DATA_FAILURE";
export const fetchBusinessChartsDataFailure = createAction(FETCH_BUSINESS_CHARTS_DATA_FAILURE);

export const FETCH_BUSINESS_CHARTS_DATA_REQUESTED = "FETCH_BUSINESS_CHARTS_DATA_REQUESTED";
export const fetchBusinessChartsDataRequested = createAction(FETCH_BUSINESS_CHARTS_DATA_REQUESTED);

export const FETCH_BUSINESS_CHARTS_DATA_SUCCESS = "FETCH_BUSINESS_CHARTS_DATA_SUCCESS";
export const fetchBusinessChartsDataSuccess = createAction(FETCH_BUSINESS_CHARTS_DATA_SUCCESS);
